import { render, staticRenderFns } from "./Apensar.vue?vue&type=template&id=0c386dff&scoped=true"
import script from "./Apensar.vue?vue&type=script&lang=js"
export * from "./Apensar.vue?vue&type=script&lang=js"
import style0 from "./Apensar.vue?vue&type=style&index=0&id=0c386dff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c386dff",
  null
  
)

export default component.exports